'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasVisitorReply = undefined;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _filter = require('transmute/filter');

var _filter2 = _interopRequireDefault(_filter);

var _some = require('transmute/some');

var _some2 = _interopRequireDefault(_some);

var _getMessages = require('../../thread-history/operators/getMessages');

var _messageTypeComparators = require('../../pubnub-message/operators/messageTypeComparators');

var _isFromVisitor = require('../../pubnub-message/operators/isFromVisitor');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasVisitorReply = exports.hasVisitorReply = function hasVisitorReply(history) {
  if (!history) {
    return false;
  }

  var messages = (0, _getMessages.getMessages)(history);

  return (0, _pipe2.default)((0, _filter2.default)(_messageTypeComparators.isChatMessage), (0, _some2.default)(_isFromVisitor.isFromVisitor))(messages);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread-history/operators/hasVisitorReply.js
// module id = 1078
// module chunks = 2 3